module.exports = __webpack_public_path__ + "static/media/forgot-password.b1835e91.png";